import styled from "styled-components";
import { themevals } from "theme/themevals";

interface CustomProps {
  $customStyles?: React.CSSProperties;
}

export const StyledSubtext = styled.p<CustomProps>`
  font-size:12px;
  color:${({$customStyles}) => $customStyles?.color || themevals.colors.base_500};
  text-align:${({$customStyles}) => $customStyles?.textAlign};
  font-family:${({$customStyles}) => $customStyles?.fontFamily};
  font-size:${({$customStyles}) => $customStyles?.fontSize};
  margin-bottom:${({$customStyles}) => $customStyles?.marginBottom};
  margin-top:${({$customStyles}) => $customStyles?.marginTop};
  margin-left:${({$customStyles}) => $customStyles?.marginLeft};
  font-weight:${({$customStyles}) => $customStyles?.fontWeight};
`